const { First } = require("react-bootstrap/esm/PageItem");

const language = {
    'pt':
    {
        add_new: 'Adicionar Nova Competição',
        add_solution: 'Adicionar Competição',
        adicionar_departamento: 'Adicionar Departamento',
        adicionar_entidade: 'Adicionar Responsáveis',
        adicionar_projeto: 'Projetos de Software',
        area_placeholder: 'Selecione a sua area',
        assistencia: 'Assistência de Software',
        assistencia_botao: 'Adicionar pedido de assistência',
        assistencia_projeto: 'Adicionar Projetos',
        assunto: 'Assunto',
        birthday: 'Data de nascimento',
        cancel: 'Cancelar', back: 'Voltar',
        city: 'Cidade',
        city_placeholder: 'Introduza a cidade',
        cliente: 'Cliente',
        cliente_placeholder: 'Selecione o Cliente',
        close: 'Fechar',
        config: 'Configuração',
        content: 'Conteúdo',
        content_edit: 'Editar conteúdo',
        content_list: 'Lista de conteúdos',
        content_new: 'Novo conteúdo',
        country: 'País',
        country_placeholder: 'Introduza o país',
        data: 'Data de Publicação',
        data_disponivel: 'Disponível até',
        data_fim: 'Data e Hora de Fim:',
        data_inicio: 'Data e Hora de Início:',
        date_creation: 'Criação',
        date_last_update: 'Última actualização',
        date_publication: 'Publicação',
        dates: 'Datas',
        dark_mode: 'Dark mode',
        delete: 'Eliminar',
        delete_cancel: 'Não',
        delete_confirm: 'Sim',
        delete_error: 'Problema ao apagar registo!',
        delete_success: 'Registo apagado com sucesso!',
        delete_text: 'Tem a certeza que pretende continuar?',
        delete_title: 'Eliminar Registo',
        departamento: 'Departamentos',
        departamento_data: 'Dados departamentais',
        departamento_placeholder: 'Dados de Departamento',
        description: 'Descrição',
        description_placeholder: 'Introduza uma descrição',
        district: 'Distrito',
        district_placeholder: 'Introduza o distrito',
        edit: 'Editar',
        edit_cancel: 'Não',
        edit_confirm: 'Sim',
        edit_error: 'Problema ao actualizar registo!',
        edit_success: 'Registo actualizado com sucesso!',
        edit_text: 'Tem a certeza que pretende continuar?',
        edit_title: 'Editar Registo',
        email: 'E-mail',
        email_placeholder: 'Introduza o e-mail',
        empresa: 'Empresa',
        empresa_placeholder: 'Introduza a Empresa',
        entity: 'Competições',
        entity_edit: 'Editar Competição',
        entity_list: 'Listagem de Competições',
        entity_new: 'Nova Competição',
        entity_type: 'Tipo de entidade',
		field_activo: 'Inscrição',
		field_available: 'Disponível',
        filter_concluido: 'Concluídos',
        filter_placeholder: 'Procurar',
        filter_resolver: 'Pedidos',
        hours: 'horas',
        id: 'ID',
        identification_number: 'Número de identificação',
        identification_number_placeholder: 'Introduza o número de identificação',
        identification_validation: 'Validade',
        image: 'Imagem',
        image_choose: 'Escolher imagem',
        imediato: 'Imediato',
        insert_cancel: 'Não',
        insert_confirm: 'Sim',
        insert_error: 'Problema ao inserir registo!',
        insert_success: 'Registo inserido com sucesso!',
        insert_text: 'Tem a certeza que pretende continuar?',
        insert_title: 'Novo Registo',
        language: 'Lingua',
        licenca: 'Licença',
        licenca_placeholder: 'Introduza o Número da Licença',
        local: 'Localidade',
        local_data: 'Dados geográficos',
        local_placeholder: 'Introduza a localidade',
        login_data: 'Dados de login',
        minutes: 'minutos',
        morada: 'Morada',
        morada_placeholder: 'Introduza a morada',
        no_solution: 'Nenhuma solução adicionada',
        no_projeto: 'Nome do Projeto Não Disponível',
        observacao: 'Observação',
        observacao_placeholder: 'Escreva algo',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Confirmação da Password',
        password_confirmation_placeholder: 'Confirme a password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Introduza a password',
        password_success: 'Successful inserted element!',
        password_text: 'As Passwords não correspondem.',
        password_title: 'Password!',
        personal_data: 'Dados pessoais',
        postal_code: 'Código-postal',
        postal_code_placeholder: 'Introduza o código-postal',
        principal: 'Principal',
        profile: 'Perfil',
        prioridade: 'Prioridade',
        projeto: 'Projetos',
        projeto_placeholder: 'Selecione o Projeto',
        remove: 'Remover',
        respons: 'Responsável',
        responsavel: 'Responsáveis',
        responsavel_placeholder: 'Selecione o Responsável',
        save: 'Salvar',
        software: 'Software',
        software_line: 'Linha de Software',
        software_line_placeholder: 'Introduza o Linha de Software',
        software_type: 'Tipo de Software',
        software_type_placeholder: 'Introduza o Tipo de Software',
        solucao: 'Solução',
        solucao_adicionadas: 'Soluções Adicionadas',
        table_actions: 'Acções',
        table_all: 'Todos',
        table_count: 'Count',
        table_date: 'Data',
        table_empty: 'Sem Resultados',
        table_parent: 'Parent',
        table_rows_per_page: 'Registos por página:',
        table_separator: 'de',
        table_state: 'Estado',
        table_thumbnail: 'Thumbnail',
        table_title: 'Título',
        table_type: 'Tipo',
        text: 'Texto',
        ticket_finish: 'Dar por Concluído o Ticket?',
        ticket_number: 'Nº',
        time: 'Tempo de Assistência',
        time_placeholder: 'Introduza o Tempo de Assistência',
        time_spent: 'Tempo Gasto',
        title: 'Título',
        title_placeholder: 'Introduza o título',
        tlm: 'Telemóvel',
        tlm_placeholder: 'Introduza o número de telemóvel',
        tlf: 'Telefone',
        tlf_placeholder: 'Introduza o número de telefone',
        total: 'Total',
        total_time_spent: 'Total de Tempo Gasto',
        type: 'Tipo de cliente',
        type_identification: 'Tipo de identificação',
        type_identification_placeholder: 'Introduza o tipo de identificação',
        type_placeholder: 'Introduza o tipo de cliente',
        username: 'Username',
        username_placeholder: 'Introduza o username',
        validade_identificacao: 'Validade da identificacao',
        vat: 'NIF',
        vat_placeholder: 'Introduza o NIF',
        village: 'Freguesia',
        village_placeholder: 'Introduza a freguesia',
        warning_cancel: 'Não',
        warning_confirm: 'Continuar',
        warning_error: 'Problema ao inserir registo!',
        warning_success: 'Registo inserido com sucesso!',
        warning_text: 'O username já existe no sistema.',
        warning_title: 'Aviso!',
        // Competição (dados gerais)
        competicao: 'Competição',
        competicao_list: 'Lista de Competições',
        competicao_placeholder: 'Nome da competição',
        dados_competicao: 'Dados da Competição',
        tipo_competicao: 'Tipo de Competição',
        modalidade: 'Modalidade',
        modalidades: 'Modalidades',
        escalao: 'Escalão',
        escaloes: 'Escalão(ões)',
        epoca: 'Época',
        inicio: 'Início',
        fim: 'Fim',
        local_competicao: 'Local da competição',
        regulamento: 'Regulamento',
        observacoes: 'Observações',

        // Responsável
        responsavel_identificacao: 'Identi. Responsável',
        responsavel_telefone: 'Tel Responsável',
        responsavel_email: 'e-mail Responsável',

        // Clubes / Atletas Inscritos  
        clube: 'Clube',
        clubes_inscritos: 'Clubes Inscritos',
        atletas_inscritos: 'Atletas Inscritos',
        inscrever_clube: 'Inscrever Clube',
        inscrever_atletas: 'Inscrever Atletas',
        inscrever_clube_title: 'Inscrever clube',
        inscrever_clube_text: 'Confirma inscrever o clube',
        inscrever_clube_text_2: 'nesta competição?',
        inscrever_atleta_title: 'Inscrever atleta',
        inscrever_atleta_text: 'Confirma inscrever o atleta',
        pesquisar_clube: 'Pesquisar Clube',
        pesquisar_atleta: 'Pesquisar Atleta',
        pesquisar_entidade_placeholder: 'Pesquisar por nome...',
        associar_confirm: 'Inscrever',
        associar_cancel: 'Cancelar',
        numero_atleta: 'Nº de Atleta',
        selecionar_clube_hint: 'Selecione um clube na lista abaixo para gerir os atletas inscritos desse clube.',

        // Remoção genérica (clube/atleta inscrito)
        remove_title: 'Remover',
        remove_text: 'Confirma remover este registo da competição?',
        remove_confirm: 'Remover',
        remove_cancel: 'Cancelar',

        // Classificações
        classificacoes: 'Classificações',
        classificacao: 'Classificação',
        classificacao_placeholder: 'Posição / pontos',

        // Genéricos usados nas tabelas/formulário
        name: 'Nome',
        select: 'Selecione',
        field_choose: 'Selecione',
        loading: 'A carregar...',
        sem_registos: 'Sem registos',
        noFile: 'Sem ficheiro',
        doc_choose: 'Escolher ficheiro',
        upload_file_error: 'Formato do ficheiro incorrecto: ',

        individual:     'Indívidual',
        tab_geral:      'Geral',
        tab_atletas:    'Clubes / Atletas',
        tab_games:      'Jogos',
        tab_time:       'Classificação',
        add_game:       'Adicionar jogo',

        numero_licenca: 'N.º Licença',
        see_game_stats: 'Ver dados do jogo',
        edit_game:      'Editar jogo',

        data_referencia:    'Data de início',
        hora_referencia:    'Hora de início',

        dorsal:             'Dorsal',
        year:               'Ano',
        first_run:          '1.ª Manga',
        second_run:         '2.ª Manga',
        total_time:         'Total',
        diff_time:          'Diferênça',


    },

    'en':
    {
        projeto: 'Project',
        add_new: 'Add New Assistance Request',
        add_solution: 'Add Solution',
        add_test_solution: 'Add Test Solution',
        adicionar_departamento: 'Add Department',
        adicionar_entidade: 'Add Responsibles',
        adicionar_projeto: 'Software Projects',
        area_placeholder: 'Select your area',
        assistencia: 'Software Assistance',
        assistencia_botao: 'Add Assistance Request',
        assistencia_projeto: 'Add Projects',
        assunto: 'Subject',
        birthday: 'Date of Birth',
        cancel: 'Cancel',
        city: 'City',
        city_placeholder: 'Enter the city',
        cliente: 'Client',
        cliente_placeholder: 'Select Client',
        close: 'Close',
        config: 'Configuration',
        content: 'Content',
        content_edit: 'Edit Content',
        content_list: 'Content List',
        content_new: 'New Content',
        country: 'Country',
        country_placeholder: 'Enter the country',
        data: 'Publication Date',
        data_disponivel: 'Available until',
        data_fim: 'End Date and Time:',
        data_inicio: 'Start Date and Time:',
        date_creation: 'Creation',
        date_last_update: 'Last Update',
        date_publication: 'Publication',
        dates: 'Dates',
        dark_mode: 'Dark mode',
        delete: 'Delete',
        delete_cancel: 'No',
        delete_confirm: 'Yes',
        delete_error: 'Problem deleting record!',
        delete_success: 'Record deleted successfully!',
        delete_text: 'Are you sure you want to continue?',
        delete_title: 'Delete Record',
        departamento: 'Departments',
        departamento_data: 'Departmental Data',
        departamento_placeholder: 'Department Data',
        description: 'Description',
        description_placeholder: 'Enter a description',
        district: 'District',
        district_placeholder: 'Enter the district',
        edit: 'Edit',
        edit_cancel: 'No',
        edit_confirm: 'Yes',
        edit_error: 'Problem updating record!',
        edit_success: 'Record updated successfully!',
        edit_text: 'Are you sure you want to continue?',
        edit_title: 'Edit Record',
        email: 'Email',
        email_placeholder: 'Enter the email',
        empresa: 'Company',
        empresa_placeholder: 'Enter the Company',
        entity: 'Competitions',
        entity_edit: 'Edit Competition',
        entity_list: 'Competition Listing',
        entity_new: 'New Competition',
        entity_type: 'Entity Type',
        filter_concluido: 'Completed',
        filter_placeholder: 'Search',
        filter_resolver: 'Requests',
        hours: 'hours',
        id: 'ID',
        identification_number: 'Identification Number',
        identification_number_placeholder: 'Enter the identification number',
        identification_validation: 'Validity',
        image: 'Image',
        image_choose: 'Choose Image',
        imediato: 'Immediately',
        insert_cancel: 'No',
        insert_confirm: 'Yes',
        insert_error: 'Problem inserting record!',
        insert_success: 'Record inserted successfully!',
        insert_text: 'Are you sure you want to continue?',
        insert_title: 'New Record',
        language: 'Language',
        licenca: 'License',
        licenca_placeholder: 'Enter the License Number',
        local: 'Location',
        local_data: 'Geographic Data',
        local_placeholder: 'Enter the location',
        login_data: 'Login Data',
        minutes: 'minutes',
        morada: 'Address',
        morada_placeholder: 'Enter the address',
        no_solution: 'No solution added',
        no_projeto: 'No project added',
        observacao: 'Observation',
        observacao_placeholder: 'Write something',
        password: 'Password',
        password_cancel: 'No',
        password_confirmation: 'Password Confirmation',
        password_confirmation_placeholder: 'Confirm the password',
        password_confirm: 'Continue',
        password_error: 'Problem inserting element!',
        password_placeholder: 'Enter the password',
        password_success: 'Successful element insertion!',
        password_text: 'Passwords do not match.',
        password_title: 'Password!',
        personal_data: 'Personal Data',
        postal_code: 'Postal Code',
        postal_code_placeholder: 'Enter the postal code',
        principal: 'Principal',
        profile: 'Profile',
        prioridade: 'Priority',
        projeto: 'Projects',
        projeto_placeholder: 'Select Project',
        remove: 'Remove',
        respons: 'Responsible',
        responsavel: 'Responsibles',
        responsavel_placeholder: 'Select the Responsible',
        save: 'Save',
        software: 'Software',
        software_line: 'Software Line',
        software_line_placeholder: 'Enter the Software Line',
        software_type: 'Software Type',
        software_type_placeholder: 'Enter the Software Type',
        solucao: 'Solution',
        solucao_adicionadas: 'Added Solutions',
        table_actions: 'Actions',
        table_all: 'All',
        table_count: 'Count',
        table_date: 'Date',
        table_empty: 'No Results',
        table_parent: 'Parent',
        table_rows_per_page: 'Records per page:',
        table_separator: 'of',
        table_state: 'State',
        table_thumbnail: 'Thumbnail',
        table_title: 'Title',
        table_type: 'Type',
        text: 'Text',
        ticket_finish: 'Mark Ticket as Completed?',
        ticket_number: 'No.',
        time: 'Assistance Time',
        time_placeholder: 'Enter the Assistance Time',
        time_spent: 'Time Spent',
        title: 'Title',
        title_placeholder: 'Enter the title',
        tlm: 'Mobile',
        tlm_placeholder: 'Enter the mobile number',
        tlf: 'Phone',
        tlf_placeholder: 'Enter the phone number',
        total: 'Total',
        total_time_spent: 'Total Time Spent',
        type: 'Customer Type',
        type_identification: 'Identification Type',
        type_identification_placeholder: 'Enter the identification type',
        type_placeholder: 'Enter the customer type',
        username: 'Username',
        username_placeholder: 'Enter the username',
        validade_identificacao: 'Validity of identification',
        vat: 'VAT',
        vat_placeholder: 'Enter the VAT',
        village: 'Village',
        village_placeholder: 'Enter the village',
        warning_cancel: 'No',
        warning_confirm: 'Continue',
        warning_error: 'Problem inserting record!',
        warning_success: 'Record inserted successfully!',
        warning_text: 'The username already exists in the system.',
        warning_title: 'Warning!',
        competicao: 'Competition',
        competicao_list: 'Competition List',
        competicao_placeholder: 'Competition name',
        dados_competicao: 'Competition Data',
        tipo_competicao: 'Competition Type',
        modalidade: 'Discipline',
        modalidades: 'Disciplines',
        escalao: 'Age Group',
        escaloes: 'Age Group(s)',
        epoca: 'Season',
        inicio: 'Start',
        fim: 'End',
        local_competicao: 'Competition venue',
        regulamento: 'Regulations',
        observacoes: 'Notes',

        responsavel_identificacao: 'Responsible - Name',
        responsavel_telefone: 'Responsible - Phone',
        responsavel_email: 'Responsible - Email',

        clube: 'Club',
        clubes_inscritos: 'Registered Clubs',
        atletas_inscritos: 'Registered Athletes',
        inscrever_clube: 'Register Club',
        inscrever_atletas: 'Register Athletes',
        inscrever_clube_title: 'Register club',
        inscrever_clube_text: 'Confirm registering the club',
        inscrever_clube_text_2: 'in this competition?',
        inscrever_atleta_title: 'Register athlete',
        inscrever_atleta_text: 'Confirm registering the athlete',
        pesquisar_clube: 'Search Club',
        pesquisar_atleta: 'Search Athlete',
        pesquisar_entidade_placeholder: 'Search by name...',
        associar_confirm: 'Register',
        associar_cancel: 'Cancel',
        numero_atleta: 'Athlete No.',
        selecionar_clube_hint: 'Select a club from the list below to manage the athletes registered for that club.',

        remove_title: 'Remove',
        remove_text: 'Confirm removing this entry from the competition?',
        remove_confirm: 'Remove',
        remove_cancel: 'Cancel',

        classificacoes: 'Results',
        classificacao: 'Result',
        classificacao_placeholder: 'Position / points',

        name: 'Name',
        select: 'Select',
        field_choose: 'Select',
        loading: 'Loading...',
        sem_registos: 'No records',
        noFile: 'No file',
        doc_choose: 'Choose file',
        upload_file_error: 'Incorrect file format: ',
    },

    'es': {

    }
}

module.exports = {
    language
};